
  <template>
 
    <div class="Rreferanse" id="back1">
       <div class="form-wrap container">
    <v-carousel >
      <v-carousel-item  v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
    </v-carousel>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { src: require("../assets/Bilder/Bilde1.jpg") },
        { src: require("../assets/Bilder/Bilde2.jpg") },
        { src: require("../assets/Bilder/Bilde3.jpg") },
        { src: require("../assets/Bilder/Bilde4.jpg") },
        { src: require("../assets/Bilder/Bilde5.jpg") },
        { src: require("../assets/Bilder/Bilde6.jpg") }
      ]
    };
  }
};
</script>

<style  scoped>


</style>

